import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type UserNumbersPreloaderService from '@/services/preloaders/userNumbersPreloaderService'

@injectable()
export default class UserNumbersCacheClearResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.UserNumbersPreloaderService)
    protected readonly userNumbersPreloaderService: UserNumbersPreloaderService,
  ) {}

  public async resolve() {
    await this.userNumbersPreloaderService.markAsNotPreloaded()
  }
}
